import { render } from "./CreateLink.vue?vue&type=template&id=b4d92f70"
import script from "./CreateLink.vue?vue&type=script&lang=js"
export * from "./CreateLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rentapplication-frontend-vue/rentapplication-frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__